exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reports-frame-style[data-v-a185322e] {\n  height: 100vh;\n  width: 100%;\n  border: 1px solid grey;\n  border-radius: 7px;\n}\ninput#algolia-search-box[data-v-a185322e] {\n  width: 90%;\n}\n@media (max-width: 768px) {\nobject[data-v-a185322e] {\n    height: 400px; /* Adjust height for smaller screens */\n}\n}\n", ""]);

// exports
